import React from "react"
import "./adminListaUtenti.css"
import MainActions from "redux-store/models/main"
import AuthActions from "redux-store/models/auth"
import CalendarRangePicker from "shared-components/CalendarRangePicker/CalendarRangePicker"
import SpanFormater from "shared-components/SpanFormater/SpanFormater"
import { switchUserStatus } from "services/auth"
import { connect } from "react-redux"
import moment from "moment"
import {
  Select,
  Pagination,
  Input,
  Button,
  Table,
  Icon,
  message,
  Checkbox,
  Modal,
  Badge,
  Popover,
  Popconfirm,
} from "antd"
import { withRouter } from "react-router"
import axios from "axios"
import { endpoint } from "../../../../config/api"
import { CSVLink } from "react-csv"
import * as MainRequest from "services/main"

const { Option } = Select

const defaultUtentiVisibleColumns = {
  Utente: true,
  "Ragione Sociale": true,
  Credito: true,
  Città: true,
  "Ultimo Deposito": true,
  "Ultimo Login": true,
  Deposito: true,
  Tipo: true,
  Stato: true,
  Listino: true,
  Impostazioni: true,
  Commission: true,
}

const csvHeaders = [
  { label: "Ragione Sociale", key: "ragione_sociale" },
  { label: "Nome Cognome", key: "nome_cognome" },
  { label: "Indirizzo", key: "indirizzo" },
  { label: "Comune", key: "comune" },
  { label: "Provincia", key: "provincia" },
  { label: "CAP", key: "cap" },
  { label: "P. IVA", key: "p_iva" },
]

class NewAdminUtenti extends React.Component {
  csvLinkRef = React.createRef()

  constructor(props) {
    super(props)

    const savedColumns = JSON.parse(localStorage.getItem("utentiVisibleColumns"))

    this.state = {
      perPage: 100,
      page_number: 1,
      username: "",
      ragione_sociale: "",
      city: "",
      user_id: "",
      isCalendarOpen: false,
      from: "",
      to: "",
      fromLabel: "",
      toLabel: "",
      filter: false,
      picker: [
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
          color: "var(--accent-bg)",
        },
      ],
      eyeClicked: false,
      isCsvLoading: false,
      exportData: [],

      utentiVisibleColumns: {
        ...defaultUtentiVisibleColumns,
        ...(savedColumns || {}),
      },
    }

    this.refresh = this.refresh.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  setCalendar = (val) => {
    this.setState({ isCalendarOpen: val })
  }

  componentDidMount() {
    const { getListinoList } = this.props
    getListinoList()

    this.initFetch()
  }

  componentDidUpdate(prevProps) {
    const { skinList, activeSkinId, fromDate } = this.props
    if (skinList !== prevProps.skinList) {
      this.initFetch()
    }

    // When activeSkinId changes
    if (activeSkinId !== prevProps.activeSkinId) {
      this.fetchUsers()
    }

    if (fromDate && fromDate !== prevProps.fromDate) {
      const label = moment(fromDate, "DD/MM/YYYY")
      this.setState({
        from: fromDate,
        to: fromDate,
        fromLabel: label,
        toLabel: label,
        perPage: 100,
      })
    }
  }

  initFetch = () => {
    const { skinList, activeSkinId, accountInfo, getUsers } = this.props

    // Roles with skins (main admin)
    if (skinList && skinList.length > 0) {
      this.setActiveSkin()

      if (activeSkinId && activeSkinId !== -1) {
        getUsers(
          null,
          {
            skin_id: activeSkinId ? activeSkinId : skinList[0]?.id,
            backoffice: true,
          },
          this.state.perPage,
          this.state.page_number,
        )
      }
      return
    }
    // Roles without skins (agents, skin admin)
    const activityId = accountInfo?.profile?.activity_id
    if (activityId) {
      getUsers(
        null,
        { skin_id: activityId, backoffice: true },
        this.state.perPage,
        this.state.page_number,
      )
    }
  }

  setActiveSkin = () => {
    const { skinList, accountInfo, activeSkinId, setActiveSkinId } = this.props
    const roleName = accountInfo?.profile?.role?.name

    const activeSkins = skinList.filter((skin) => skin.status === 1)
    const getFirstActiveSkinId = () =>
      activeSkins.length > 0 ? activeSkins[0].id : undefined

    const computedSkinId =
      roleName === "super_admin" || roleName === "agent"
        ? accountInfo.profile.activity_id
        : activeSkinId !== -1
          ? activeSkinId
          : getFirstActiveSkinId()

    setActiveSkinId(computedSkinId)
  }

  fetchUsers = () => {
    const { skinList, accountInfo, activeSkinId, getUsers } = this.props
    const roleName = accountInfo?.profile?.role?.name
    const isSpecial = activeSkinId === -1 && roleName !== "support"

    const userParams = {
      skin_id: isSpecial
        ? skinList[0]?.id
        : accountInfo?.profile?.activity_id || activeSkinId,
      ...(!isSpecial && { backoffice: true }),
    }

    getUsers(null, userParams, this.state.perPage, 1)
  }

  refresh = () => {
    this.setState(
      {
        username: "",
        ragione_sociale: "",
        city: "",
        user_id: "",
        from: "",
        to: "",
        fromLabel: "",
        toLabel: "",
        filter: false,
      },
      this.fetchUsers,
    )
  }

  handleSearch = () => {
    const { getUsers, activeSkinId } = this.props
    const { username, ragione_sociale, city, from, to, perPage } = this.state
    getUsers(
      null,
      {
        skin_id: activeSkinId === -1 ? this.props.skinList[0]?.id : activeSkinId,
        ...(this.props.activeSkinId !== -1 && { backoffice: true }),
        username: username,
        ragione_sociale: ragione_sociale,
        city: city,
        from_last_login: from,
        to_last_login: to,
      },
      perPage,
      1,
    )
    this.setState({
      page_number: 1,
    })
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys }) => {
      return (
        <div style={{ padding: 8 }}>
          <Input
            ref={(node) => {
              this.searchInput = node
            }}
            placeholder={`Search ${dataIndex}`}
            value={this.state[dataIndex] || selectedKeys[0]}
            onChange={(e) => {
              const value = e.target.value

              this.setState({ [dataIndex]: value }, () => {
                setSelectedKeys(value ? [value] : [])

                if (value.length >= 4 || value.length === 0) {
                  setTimeout(() => {
                    this.handleSearch()
                  }, 200)
                }
              })
            }}
            onPressEnter={() => this.handleSearch()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => this.handleSearch()}
            icon="search"
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => this.refresh()} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      )
    },
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select())
      }
    },
    render: (text) => (this.state.searchedColumn === dataIndex ? text : text),
  })

  handleSubmit(e) {
    const { username, ragione_sociale, city, user_id, from, to, perPage } =
      this.state
    e.preventDefault()
    this.props.getUsers(
      null,
      {
        skin_id: this.props.activeSkinId,
        ...(this.props.activeSkinId !== -1 && { backoffice: true }),
        username: username,
        ragione_sociale: ragione_sociale,
        city: city,
        user_id: user_id,
        from_last_login: from,
        to_last_login: to,
      },
      perPage,
      1,
    )
    this.setState({
      page_number: 1,
      filter: true,
    })
  }

  handleUtentiCheckboxChange = (e, key) => {
    const updatedColumns = {
      ...this.state.utentiVisibleColumns,
      [key]: e.target.checked,
    }

    this.setState({
      utentiVisibleColumns: updatedColumns,
    })

    localStorage.setItem("utentiVisibleColumns", JSON.stringify(updatedColumns))
  }

  getAllAgencies = (users = []) => {
    let agencies = []

    users.forEach((user) => {
      if (user.role === "agency") {
        agencies.push(user)
      }

      if (user.children && user.children.length > 0) {
        agencies = [...agencies, ...this.getAllAgencies(user.children)]
      }
    })

    return agencies
  }

  getAllUsersForExport = async () => {
    this.setState({ isCsvLoading: true })

    try {
      const response = await MainRequest.fetchUsers(
        null,
        this.props.activeSkinId !== -1 && {
          skin_id: this.props.activeSkinId,
        },
        this.props.activeSkinId !== -1 ? { backoffice: true } : {},
        1000,
        1,
        this.state.username ? { username: this.state.username } : {},
        this.state.ragione_sociale
          ? { ragione_sociale: this.state.ragione_sociale }
          : {},
        this.state.city ? { city: this.state.city } : {},
        this.state.user_id ? { user_id: this.state.user_id } : {},
        null,
        null,
        null,
      )

      const users = response?.data?.users || []

      // flatten children + keep only agencies
      const agencies = this.getAllAgencies(users)

      const exportData = agencies.map((user) => ({
        ragione_sociale: user.rag_soc || "-",
        nome_cognome: `${user.first_name || ""} ${user.last_name || ""}`.trim(),
        indirizzo: user.address || "-",
        comune: user.city || "-",
        provincia: user.comune_code || "-",
        cap: user.cap || "-",
        p_iva: user.p_iva || "-",
      }))

      this.setState({
        exportData,
        isCsvLoading: false,
      })

      return exportData
    } catch (err) {
      console.error("Export users error:", err)

      this.setState({
        isCsvLoading: false,
      })

      return []
    }
  }

  render() {
    const {
      userList,
      LoaderAU,
      screenWidth,
      activeSkinId,
      accountInfo,
      total_pages,
      setDepositoModalAdmin,
      setUserMessageModalAdmin,
      listinoList,
      changeUserListino,
      updateUserType,
    } = this.props
    const { perPage, page_number } = this.state

    const showCity =
      Array.isArray(userList) && userList.some((user) => user.city !== "-")

    const Special =
      activeSkinId === -1 && accountInfo?.profile?.role?.name !== "support"

    var columns =
      screenWidth <= 768
        ? [
            this.state.utentiVisibleColumns["Utente"] && {
              title: "Utente",
              dataIndex: "username",
              key: "username",
              ellipsis: true,
              className: "utente-col",
              width: "50%",
              ...this.getColumnSearchProps("username"),
              render: (text, record) => (
                <span
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    width: "100px",
                  }}
                  className="user-icons"
                  onClick={() => {
                    if (activeSkinId !== -1) {
                      this.props.history.push(
                        `/back-office/movimenti/${record.username}`,
                      )
                    }
                  }}
                >
                  {record.role === "agency" ? (
                    <i className="fas fa-store" style={{ marginRight: 6 }}></i>
                  ) : record.role === "user" ? (
                    <i className="fal fa-user" style={{ marginRight: 6 }}></i>
                  ) : record.role === "agent" ? (
                    <i className="fas fa-user-tie" style={{ marginRight: 6 }}></i>
                  ) : null}

                  <span style={{ display: "inline-block", lineHeight: 1.2 }}>
                    <SpanFormater
                      myClassName="nomeTd"
                      Word={text}
                      size={35}
                      nrOfRows={1}
                      formatWord={true}
                    />
                    <br />
                    <span style={{ fontSize: 11, color: "#999" }}>
                      (ID: {record.id})
                    </span>
                  </span>
                </span>
              ),
            },

            this.state.utentiVisibleColumns["Credito"] && {
              title: "Credito",
              dataIndex: "wallet",
              key: "wallet",
              ellipsis: true,
              width: "30%",
              align: "right",
              render: (text) => `${text}€`,
            },
            this.state.utentiVisibleColumns["Impostazioni"] && {
              title: "Impostazioni",
              dataIndex: "refresh",
              key: "refresh",
              ellipsis: true,
              width: "20%",
              align: "center",
              render: (text, record) => (
                <div className="circle-icons">
                  <i
                    className="fas fa-eye"
                    onClick={(e) => {
                      this.props.editUtentiRespModal({
                        visibility: true,
                        data: { ...record },
                      })
                    }}
                  ></i>
                </div>
              ),
              onHeaderCell: () => {
                return {
                  onClick: () => {
                    this.refresh()
                  },
                }
              },
            },
          ]
        : [
            this.state.utentiVisibleColumns["Utente"] && {
              title: "Utente",
              dataIndex: "username",
              key: "username",
              ellipsis: true,
              className: "utente-col",
              width: "18%",
              ...this.getColumnSearchProps("username"),
              render: (text, record) => (
                <span
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    width: "100px",
                  }}
                  title={record.full_name}
                  className="user-icons"
                  onClick={() => {
                    if (activeSkinId !== -1) {
                      this.props.history.push(
                        `/back-office/movimenti/${record.username}`,
                      )
                    }
                  }}
                >
                  {record.role === "agency" ? (
                    <i className="fas fa-store" style={{ marginRight: 6 }}></i>
                  ) : record.role === "user" ? (
                    <i className="fal fa-user" style={{ marginRight: 6 }}></i>
                  ) : record.role === "agent" ? (
                    <i className="fas fa-user-tie" style={{ marginRight: 6 }}></i>
                  ) : null}

                  <span style={{ display: "inline-block", lineHeight: 1.2 }}>
                    <SpanFormater
                      myClassName="nomeTd"
                      Word={text}
                      size={35}
                      nrOfRows={1}
                      formatWord={true}
                    />
                    <br />
                    <span style={{ fontSize: 11, color: "#999" }}>
                      (ID: {record.id})
                    </span>
                  </span>
                </span>
              ),
            },
            this.state.utentiVisibleColumns["Ragione Sociale"] && {
              title: "Ragione Sociale",
              dataIndex: "ragione_sociale",
              key: "ragione_sociale",
              ellipsis: true,
              width: "12%",
              ...this.getColumnSearchProps("ragione_sociale"),
              render: (text, record) => (
                <SpanFormater
                  myClassName="nomeTd"
                  Word={text}
                  size={30}
                  nrOfRows={1}
                  formatWord={true}
                />
              ),
            },
            this.state.utentiVisibleColumns["Credito"] && {
              title: "Credito",
              dataIndex: "wallet",
              key: "wallet",
              ellipsis: true,
              width: "7%",
              align: "right",
              render: (text) => `${text}€`,
            },
            this.state.utentiVisibleColumns["Città"] && {
              title: "Città",
              dataIndex: "city",
              key: "city",
              ellipsis: true,
              width: "8%",
              ...this.getColumnSearchProps("city"),
              render: (text, record) => (
                <SpanFormater
                  myClassName="nomeTd"
                  Word={text}
                  size={30}
                  nrOfRows={1}
                  formatWord={true}
                />
              ),
            },
            this.state.utentiVisibleColumns["Ultimo Deposito"] && {
              title: "Ultimo Deposito",
              dataIndex: "last_deposit",
              key: "last_deposit",
              ellipsis: true,
              width: "12%",
              responsive: ["xl"],
            },
            this.state.utentiVisibleColumns["Ultimo Login"] && {
              title: (
                <span>
                  Ultimo Login <i className="fal fa-calendar-alt"></i>
                </span>
              ),
              dataIndex: "last_login_time",
              key: "last_login_time",
              ellipsis: true,
              width: "12%",
              className: "ultimo-login-col",
              responsive: ["xl"],
              onHeaderCell: () => {
                return {
                  onClick: () => {
                    this.setCalendar(true)
                  },
                }
              },
            },
            accountInfo?.profile?.role?.name === "agent" ||
            accountInfo?.profile?.role?.name === "super_admin"
              ? null
              : this.state.utentiVisibleColumns["Deposito"] && {
                  title:
                    accountInfo?.profile?.role?.name !== "main_admin"
                      ? "Deposito"
                      : "Deposito/Addebito",
                  dataIndex: "operazioni",
                  key: "operazioni",
                  ellipsis: true,
                  width: "15%",
                  align: "center",
                  render: (text, record) => (
                    <div className="operazioni-buttons">
                      <Button
                        className={`deposito-btn ${
                          record.status !== 1 ? "disabled" : ""
                        }`}
                        disabled={record.status !== 1}
                        onClick={() => {
                          setDepositoModalAdmin({
                            depositoModalVis: true,
                            type: "deposit",
                            username: record.username,
                            id: record.id,
                          })
                        }}
                      >
                        Deposito
                      </Button>
                      {this.props.accountInfo?.profile.role?.name !==
                        "super_admin" && (
                        <Button
                          className="addebito-btn"
                          onClick={() => {
                            setDepositoModalAdmin({
                              depositoModalVis: true,
                              type: "withdraw",
                              username: record.username,
                              id: record.id,
                            })
                          }}
                        >
                          Addebito
                        </Button>
                      )}
                    </div>
                  ),
                },
            accountInfo?.profile?.role?.name === "main_admin" &&
              !Special &&
              this.state.utentiVisibleColumns["Tipo"] && {
                title: "Tipo",
                dataIndex: "type",
                key: "type",
                ellipsis: true,
                width: "15%",
                align: "center",
                render: (text, record) => {
                  if (record.role !== "agency" && record.role !== "user") {
                    return null
                  }

                  const types = ["POS", "KIOSK", "API"]

                  return (
                    <div
                      className="operazioni-buttons"
                      style={{
                        display: "flex",
                        gap: "2px",
                        justifyContent: "center",
                      }}
                    >
                      {types.map((t) => (
                        <Button
                          key={t}
                          type={
                            record.type?.toUpperCase() === t ? "primary" : "default"
                          }
                          onClick={() => {
                            Modal.confirm({
                              title:
                                "Sei sicuro di voler cambiare il tipo dell'utente?",
                              content: `L'utente: ${record.username}\nNuovo tipo: ${t}`,
                              okText: "Sì",
                              cancelText: "No",
                              onOk: () => {
                                updateUserType(record.id, t.toLowerCase())
                                setTimeout(() => {
                                  this.fetchUsers()
                                }, 500)
                              },
                            })
                          }}
                        >
                          {t}
                        </Button>
                      ))}
                    </div>
                  )
                },
              },
            accountInfo?.profile?.role?.name === "main_admin" &&
              !Special &&
              this.state.utentiVisibleColumns["Stato"] && {
                title: "Stato",
                width: "5%",
                dataIndex: "heartbeat_status",
                key: "heartbeat_status",
                align: "center",
                ellipsis: true,
                render: (status, record) =>
                  record.type === "api" ? (
                    "-"
                  ) : (
                    <Badge
                      color={status === "online" ? "green" : "red"}
                      size="big"
                    />
                  ),
              },
            accountInfo?.profile?.role?.name === "main_admin" &&
              !Special &&
              this.state.utentiVisibleColumns["Listino"] && {
                title: "Listino",
                dataIndex: "listino",
                key: "listino",
                ellipsis: true,
                width: "12%",
                align: "center",
                render: (text, record) =>
                  this.props.accountInfo?.profile.role?.name !== "super_admin" &&
                  accountInfo?.profile?.role?.name !== "agent" &&
                  record.role !== "agent" && (
                    <Select
                      style={{ width: 110 }}
                      value={text}
                      onChange={(e) => {
                        changeUserListino(record.id, e)
                        this.fetchUsers()
                      }}
                    >
                      {listinoList &&
                        listinoList.map((listino) => (
                          <Option key={listino.id} value={listino.id}>
                            {listino.name}
                          </Option>
                        ))}
                    </Select>
                  ),
              },
            this.state.utentiVisibleColumns["Impostazioni"] && {
              title: "Impostazioni",
              dataIndex: "refresh",
              key: "refresh",
              ellipsis: true,
              width: "12%",
              align: "center",
              render: (text, record) => (
                <div className="circle-icons">
                  {this.props.accountInfo?.profile?.role?.name !== "agent" && (
                    <i
                      className={`fas fa-envelope${
                        record.status == 1 ? "" : " disabled"
                      }`}
                      onClick={() => {
                        record.status == 1 &&
                          setUserMessageModalAdmin({
                            userMsgModalVis: true,
                            username: record.username,
                            id: record.id,
                          })
                      }}
                    ></i>
                  )}

                  <i
                    className={`fas fa-lock${
                      record.status !== 1 ? "-alt" : "-open-alt active"
                    }`}
                    onClick={async (e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      const changedStatus = record.status !== 1 ? 1 : Special ? 0 : 3
                      switchUserStatus(
                        record.id,
                        changedStatus,
                        () => {
                          changedStatus === 1
                            ? message.success(
                                `lo stato dell ${
                                  record.username
                                } ${`è cambiato : 'ATTIVATO'`}`,
                              )
                            : message.error(
                                `lo stato dell ${
                                  record.username
                                } ${`è cambiato : 'DISATTIVATO'`}`,
                              )
                          this.props.getUsers(
                            null,
                            Special
                              ? { skin_id: this.props.skinList[0]?.id }
                              : {
                                  skin_id: this.props.activeSkinId,
                                  ...(this.props.activeSkinId !== -1 && {
                                    backoffice: true,
                                  }),
                                },
                            perPage,
                            page_number,
                            true,
                          )
                        },
                        accountInfo.role,
                        activeSkinId,
                      )
                    }}
                  ></i>
                  <i
                    className="fas fa-eye"
                    onClick={async (e) => {
                      e.preventDefault()
                      e.stopPropagation()

                      const { accountInfo, activeSkinId, history, addEditSkin } =
                        this.props

                      if (accountInfo.profile.role.name !== "agent") {
                        this.props.getAgents(activeSkinId)
                      }

                      if (activeSkinId === -1) {
                        history.push(`/back-office/CreateSkin`)

                        const token = accountInfo?.token

                        const getSkinDetails = async (id) => {
                          try {
                            const response = await axios.get(
                              `${endpoint}single-skin/${id}`,
                              {
                                headers: {
                                  Authorization: `Bearer ${token}`,
                                },
                              },
                            )
                            return response.data.data
                          } catch (err) {
                            console.error(err)
                            return null
                          }
                        }

                        const details = await getSkinDetails(record.id)
                        const isSameSkin = addEditSkin?.skinId === record.id

                        this.props.addEditSkinDetails({
                          skinDetails: details,
                          skinId: record.id,
                          skinName: record.username,
                          skinPannel: true,
                          stepNumber: 1,
                          step1: isSameSkin ? addEditSkin?.step1 || {} : {},
                          changedValues: addEditSkin.changedValues,
                        })
                      } else {
                        if (record) {
                          if (record.role === "user") {
                            this.props.getUserByUserId(record.id, activeSkinId)
                          } else if (record.role === "agent") {
                            this.props.getAgentByUserId(record.id, activeSkinId)
                          } else {
                            this.props.getUserDetail(record.id, activeSkinId)
                          }
                        }
                      }

                      if (
                        record.role === "agent" ||
                        record.role === "agency" ||
                        record.role === "user"
                      ) {
                        history.push(
                          `/back-office/edit/${record.id}?role=${record.role}`,
                        )
                      }
                    }}
                  ></i>
                  <Popconfirm
                    title="Resettare il 2FA?"
                    description="L'autenticazione a due fattori verrà disattivata per questo utente."
                    okText="Reset"
                    cancelText="Annulla"
                    onConfirm={() => {
                      console.log(record)
                      this.props.resetFa(record.id)
                    }}
                  >
                    <i className="fas fa-qrcode" style={{ cursor: "pointer" }}></i>
                  </Popconfirm>

                  {/* {this.props.accountInfo?.profile.role?.name !== "super_admin" &&
                    accountInfo?.profile?.role?.name !== "agent" && (
                      <img
                        style={{ cursor: "pointer" }}
                        src={
                          images[
                            record?.sepafin_active ? "sepafinIcon" : "mrPayIcon"
                          ]
                        }
                        onClick={() =>
                          this.props.activateDeactivateSepafin(record.id)
                        }
                        alt="sepafin icon"
                      />
                    )} */}
                </div>
              ),
              onHeaderCell: () => {
                return {
                  onClick: () => {
                    this.refresh()
                  },
                }
              },
            },
            accountInfo?.profile?.role?.name === "main_admin" &&
              this.state.utentiVisibleColumns["Commission"] && {
                title: "Commission",
                dataIndex: "commission",
                key: "commission",
                align: "center",
                ellipsis: true,
                width: "6%",
                responsive: ["xl"],
                render: (text, record) => (
                  <Checkbox
                    checked={text}
                    onClick={() => {
                      console.log(this.props.activeSkinId, record)
                      this.props.updateGetCommission(
                        this.props.activeSkinId !== -1 ? record.id : record.user_id,
                      )
                      this.fetchUsers()
                    }}
                  />
                ),
              },
          ].filter(Boolean)

    // Remove City Column
    if (!showCity) {
      const index = columns.findIndex((column) => column.key === "city")
      if (index !== -1) {
        columns.splice(index, 1)
      }
    }

    // Remove Ultimo Deposito && Ultimo Login Columns for screens smaller than 1440px
    if (screenWidth < 1440) {
      const keysToRemove = ["last_login_time", "last_deposit"]
      keysToRemove.forEach((key) => {
        const index = columns.findIndex((column) => column.key === key)
        if (index !== -1) {
          columns.splice(index, 1)
        }
      })
    }

    // Remove Supplier Column if role is not admin
    if (accountInfo?.profile?.role?.name !== "main_admin") {
      const index = columns.findIndex((column) => column.key === "supplier")
      if (index !== -1) {
        columns.splice(index, 1)
      }
    }

    // Function that recursively applies modifications to all nesting levels of the children data
    const applyModificationsToChildren = (data) => {
      return data?.map((u) => ({
        ...u,
        id: u.id,
        username: u.username,
        ragione_sociale: u.rag_soc,
        wallet: u.wallet,
        city: u.city,
        supplier: u.supplier,
        last_login_time:
          !u.last_login_time || u.last_login_time === "-"
            ? "-"
            : moment(u.last_login_time, "DD-MM-YYYY hh:mm:ss").format(
                "DD/MM/YYYY HH:mm:ss",
              ),
        role: u.role,
        sepafin_active: u.sepafin_active,
        status: u.status,
        last_deposit:
          !u.last_deposit || u.last_deposit === "-"
            ? "-"
            : moment(u.last_deposit, "DD-MM-YYYY hh:mm:ss").format(
                "DD/MM/YYYY HH:mm:ss",
              ),
        commission: u.get_commission,
        user_id: u.user_id,
        listino: u.listino_id,
        type: u.type,
        heartbeat_status: u.heartbeat_status,
        full_name: u.first_name + " " + u.last_name,
        children:
          u?.children?.length > 0 && applyModificationsToChildren(u?.children),
      }))
    }

    var data =
      userList && Array.isArray(userList) && applyModificationsToChildren(userList)

    return (
      <div className="AdminListaUtenti">
        {this.props.MessaggiComponent}
        {this.state.isCalendarOpen && (
          <CalendarRangePicker
            setStateFunc={(item) => {
              this.setState({
                picker: [item.selection],
                from: moment(item.selection.startDate).format("YYYY-MM-DD"),
                to: moment(item.selection.endDate).format("YYYY-MM-DD"),
                fromLabel: moment(item.selection.startDate).format("DD/MM/YYYY"),
                toLabel: moment(item.selection.endDate).format("DD/MM/YYYY"),
              })
            }}
            setStateFuncEmpty={() => {
              this.setState({
                from: "",
                to: "",
                fromLabel: "",
                toLabel: "",
              })

              this.props.getUsers(
                null,
                {
                  skin_id: this.props.activeSkinId,
                  ...(this.props.activeSkinId !== -1 && { backoffice: true }),
                  username: this.state.username,
                  ragione_sociale: this.state.ragione_sociale,
                  city: this.state.city,
                  from_last_login: "",
                  to_last_login: "",
                },
                perPage,
                1,
              )
            }}
            picker={this.state.picker}
            setCalendar={this.setCalendar}
            handleSubmit={this.handleSubmit}
          />
        )}
        <div
          className={`utenti-header ${
            this.props.activeSkinId !== -1 ? "activeSkin" : ""
          }`}
        >
          <div
            style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
          >
            <Icon type="usergroup-add" />
            <h5 onClick={this.refresh}>Utenti</h5>
          </div>

          {this.props.activeSkinId !== -1 &&
            accountInfo?.profile?.role?.name !== "support" && (
              <div
                className="utenti-header-actions"
                style={{ display: "flex", marginBottom: 4 }}
              >
                <Button
                  onClick={() => {
                    this.props.history.push("/back-office/registraAgenzia")
                  }}
                  className="register-btn"
                  style={{
                    marginLeft: 20,
                    marginRight: 10,
                  }}
                  type="primary"
                >
                  Registra Agenzia
                </Button>
                {(accountInfo?.profile?.role?.name === "main_admin" ||
                  accountInfo?.profile?.role?.name === "super_admin") && (
                  <Button
                    onClick={() => {
                      this.props.history.push("/back-office/registraAgente")
                    }}
                    className="register-btn"
                    type="primary"
                  >
                    Registra Agente
                  </Button>
                )}
              </div>
            )}

          <div
            className="utenti-filters"
            style={{ display: "flex", gap: 10, marginBottom: 3 }}
          >
            <Input
              style={{ width: 200 }}
              placeholder="Cerca Utente"
              type="text"
              suffix={<Icon type="search" />}
              value={this.state.username}
              onChange={(e) => {
                const value = e.target.value

                this.setState({ username: value })

                if (value.length >= 3) {
                  setTimeout(() => {
                    this.handleSearch()
                  }, 200)
                } else if (value.length === 0) {
                  this.handleSearch()
                }
              }}
            />

            <Input
              style={{ width: 200 }}
              placeholder="Cerca Ragione Sociale"
              type="text"
              suffix={<Icon type="search" />}
              value={this.state.ragione_sociale}
              onChange={(e) => {
                const value = e.target.value

                this.setState({ ragione_sociale: value }, () => {
                  if (value.length >= 3 || value.length === 0) {
                    setTimeout(() => {
                      this.handleSearch()
                    }, 200)
                  }
                })
              }}
            />
            <Button
              loading={this.state.isCsvLoading}
              size="small"
              style={{
                border: "none",
                display: "inline-flex",
                alignItems: "center",
                color: "#0078ff",
                background: "transparent",
                marginTop: 5,
              }}
              onClick={async () => {
                const data = await this.getAllUsersForExport()
                if (data.length > 0) {
                  setTimeout(() => {
                    this.csvLinkRef.current.link.click()
                  }, 100)
                }
              }}
            >
              <i
                className="far fa-file-csv"
                style={{ marginRight: "4px", fontSize: "16px", fontWeight: 700 }}
              />
              .Csv
            </Button>

            <CSVLink
              data={this.state.exportData}
              headers={csvHeaders}
              filename={`users_skin_${this.props.activeSkinId}.csv`}
              ref={this.csvLinkRef}
              style={{ display: "none" }}
            />
          </div>

          <Popover
            placement="bottom"
            content={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 5,
                }}
              >
                {Object.keys(this.state.utentiVisibleColumns).map((colKey) => (
                  <Checkbox
                    key={colKey}
                    checked={this.state.utentiVisibleColumns[colKey]}
                    onChange={(e) => this.handleUtentiCheckboxChange(e, colKey)}
                  >
                    {colKey}
                  </Checkbox>
                ))}
              </div>
            }
            trigger="click"
          >
            <Button
              style={{
                height: 37,
                marginLeft: "auto",
                marginBottom: 2,
                marginRight: 5,
              }}
            >
              Opzioni Tabella
            </Button>
          </Popover>
        </div>
        <div
          className={`AdminListaUtentiRow ${
            this.props.activeSkinId !== -1 ? "activeSkin" : ""
          }`}
        >
          {LoaderAU && LoaderAU === true ? (
            <div className="loaderAdmin">Loading...</div>
          ) : (
            <Table
              dataSource={data}
              columns={columns}
              rowKey={(record) => record.id}
              rowClassName={(record) =>
                record.role === "user"
                  ? "data-row user"
                  : record.role === "agency" && record?.children?.length > 0
                    ? "data-row agency"
                    : record.role === "agent" && record?.children?.length > 0
                      ? "data-row agent"
                      : "data-row"
              }
              pagination={false}
            />
          )}
        </div>
        <div className="paginationWrapper">
          <Pagination
            current={this.state.page_number || 1}
            onChange={(e) => {
              this.setState({ page_number: e })
              !this.state.filter
                ? this.props.getUsers(
                    null,
                    {
                      skin_id: this.props.activeSkinId,
                      ...(this.props.activeSkinId !== -1 && { backoffice: true }),
                    },
                    perPage,
                    e,
                  )
                : this.props.getUsers(
                    null,
                    {
                      skin_id: this.props.activeSkinId,
                      ...(this.props.activeSkinId !== -1 && { backoffice: true }),
                      username: this.state.username,
                      ragione_sociale: this.state.ragione_sociale,
                      city: this.state.city,
                      user_id: this.state.user_id,
                      from_last_login: this.state.from,
                      to_last_login: this.state.to,
                    },
                    perPage,
                    e,
                  )
            }}
            total={total_pages ? total_pages * 10 : 10}
          />
          <Select
            defaultValue={100}
            onChange={(e) => {
              this.setState({ perPage: parseInt(e), clickedPage: 1 }, () => {
                !this.state.filter
                  ? this.props.getUsers(
                      null,
                      {
                        skin_id: this.props.activeSkinId,
                        ...(this.props.activeSkinId !== -1 && { backoffice: true }),
                      },
                      e,
                      page_number,
                    )
                  : this.props.getUsers(
                      null,
                      {
                        skin_id: this.props.activeSkinId,
                        ...(this.props.activeSkinId !== -1 && { backoffice: true }),
                        username: this.state.username,
                        ragione_sociale: this.state.ragione_sociale,
                        city: this.state.city,
                        user_id: this.state.user_id,
                        from_last_login: this.state.from,
                        to_last_login: this.state.to,
                      },
                      e,
                      page_number,
                    )
              })
            }}
            value={this.state.perPage}
          >
            <Option value={10}>10 / Pagina</Option>
            <Option value={25}>25 / Pagina</Option>
            <Option value={50}>50 / Pagina</Option>
            <Option value={100}>100 / Pagina</Option>
          </Select>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
  userList: state.main.userList.users,
  total_pages: state.main.userList.total_pages,
  LoaderAU: state.main.LoaderAU,
  screenWidth: state.main.screenWidth,
  accountInfo: state.auth.accountInfo,
  skinList: state.auth.skinList,
  listinoList: state.main.listinoList,
  addEditSkin: state.auth.addEditSkin,
})
export default connect(mapStateToProps, { ...MainActions, ...AuthActions })(
  withRouter(NewAdminUtenti),
)
